import React from 'react';
import IconComment from './IconComment';
import IconDisqualified from './IconDisqualified';
import IconInjured from './IconInjured';
import IconOweMoney from './IconOweMoney';
import IconQualified from './IconQualified';
import IconTrophyFirst from './IconTrophyFirst';
import IconTrophySecond from './IconTrophySecond';
import IconTrophyThird from './IconTrophyThird';
var IconDashboard = function (props) {
    switch (props.type) {
        case 'IconComment':
            return React.createElement(IconComment, null);
        case 'IconDisqualified':
            return React.createElement(IconDisqualified, null);
        case 'IconInjured':
            return React.createElement(IconInjured, null);
        case 'IconOweMoney':
            return React.createElement(IconOweMoney, null);
        case 'IconQualified':
            return React.createElement(IconQualified, null);
        case 'IconTrophyFirst':
            return React.createElement(IconTrophyFirst, null);
        case 'IconTrophySecond':
            return React.createElement(IconTrophySecond, null);
        case 'IconTrophyThird':
            return React.createElement(IconTrophyThird, null);
        default:
            return null;
    }
};
export default IconDashboard;



//////////////////
// WEBPACK FOOTER
// ./src/imports/components/Scoreboard/components/IconDashboard/index.tsx
// module id = 262
// module chunks = 0